import { render, staticRenderFns } from "./CRender.vue?vue&type=template&id=037968eb"
import script from "./CRender.vue?vue&type=script&setup=true&lang=ts"
export * from "./CRender.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports